"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeToken = void 0;
exports.getUserIdFromToken = getUserIdFromToken;
exports.isExpired = isExpired;
exports.needRefresh = needRefresh;
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var decodeToken = exports.decodeToken = _jwtDecode.default;
function getUserIdFromToken(token) {
  return (decodeToken(token) || {})._user;
}

// cookie is setted for 30 days for user and 12h for guest
var TWENTY_HEIGHT_DAYS = 2419200;
var ONE_DAY = 86000;
var ELEVEN_HOURS = 39400;
var ONE_HOURS = 3600;
function needRefresh(token, isGuest) {
  var {
    iat,
    exp
  } = decodeToken(token);
  var now = Math.round(Date.now() / 1000);
  var expLimit = isGuest ? ONE_HOURS : ONE_DAY;
  var iatLimit = isGuest ? ELEVEN_HOURS : TWENTY_HEIGHT_DAYS;
  return exp - now < expLimit || now - iat > iatLimit;
}
function isExpired(token) {
  var {
    exp
  } = decodeToken(token);
  var now = Math.round(Date.now() / 1000);
  return exp < now;
}